module.exports = __webpack_public_path__ + "assets/8be2f07d678b1897149736d5c7449647.png";